import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-invalid',
  templateUrl: './reset-password-invalid.component.html',
  styleUrls: ['./reset-password-invalid.component.scss'],
})
export class ResetPasswordInvalidComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
